import React from 'react';
import { CheckIcon } from 'lucide-react';
import { images, offerIncludes } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { Price } from './Price';
export function OfferStack() {
  return <section id="offer" className="bg-cream py-14 lg:py-24" data-id="element-107" data-mp="2ptvcdgkewsi6">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-108" data-mp="2kwbn7lm6evbg">
        <SectionHeading title="Get the Complete Worry-to-Brave Toolkit Today" data-id="element-109" data-mp="2kwv2svoct7mb" />

        <div className="mt-8 grid items-center gap-8 lg:mt-12 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:gap-14" data-id="element-110" data-mp="1x7ahw78n40ae">
          <img src={images.bundle} alt="Everything inside The Worry-to-Brave Toolkit: six volumes and five bonuses" loading="lazy" className="-mx-2 w-[calc(100%+1rem)] max-w-[640px] sm:mx-auto sm:w-full" data-id="element-111" data-mp="1t2t2ek9bc95f" />

          <div data-id="element-112" data-mp="1eeyah634q8te">
            <div className="rounded-[28px] bg-paper p-6 shadow-sheet sm:p-10" data-id="element-113" data-mp="1eef32jb3v2tm">
              <p className="font-display text-[21px] uppercase tracking-[0.05em] text-ink" data-id="element-114" data-mp="19fvgqhslnp0q">The Worry-to-Brave Toolkit</p>
              <ul className="mt-5 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-1" data-id="element-115" data-mp="14ok2b14c21gi">
                {offerIncludes.map(item => <li key={item} className="flex items-center gap-3 text-[15px] text-ink sm:text-[16px]" data-id="element-116" data-mp="19ltu2nf72p7i">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage-wash text-sage-deep" data-id="element-117" data-mp="1jdzrico7tyu3">
                      <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-118" data-mp="lr0q5omkw2pv" />
                    </span>
                    {item}
                  </li>)}
              </ul>
              <div className="my-7 border-t border-dashed border-cream-line" data-id="element-119" data-mp="vnc5yoldnap2" />
              <Price data-id="element-120" data-mp="zqic7w8hp1vj" />
            </div>

            <div className="mt-4 flex items-center gap-4 rounded-2xl border border-sage/70 bg-sage-wash p-5" data-id="element-121" data-mp="zrjy6vr1n8s1">
              <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-full border border-dashed border-sage-deep/60 bg-paper" aria-hidden="true" data-id="element-122" data-mp="273ajb4nl8iw3">
                <span className="font-display text-[28px] leading-none text-ink" data-id="element-123" data-mp="71b3zhwn7bp6">7</span>
                <span className="text-[8px] font-bold uppercase tracking-[0.14em] text-sage-deep" data-id="element-124" data-mp="73nhnivdazwf">Days</span>
              </div>
              <div data-id="element-125" data-mp="g1hd6rlb5pij">
                <p className="font-display text-[20px] leading-tight text-ink" data-id="element-126" data-mp="g327cg3pn6fv">7-Day Guarantee</p>
                <p className="mt-1 text-[14px] leading-snug text-ink-soft" data-id="element-127" data-mp="3oiubj1gy1k3h">
                  Explore the toolkit for 7 days and see how the resources fit your family’s needs. Your purchase is protected by our
                  7-Day Guarantee.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}